"use client";

import { useState } from "react";

const BookingSection = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="relative w-full h-full flex items-center justify-center overflow-hidden rounded-lg">
      {/* Animated gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-gradient-start via-gradient-mid to-gradient-end animate-gradient-shift bg-[length:400%_400%] rounded-lg" />

      {/* Content */}
      <div className="relative z-10 w-full h-full p-4 md:p-8">
        <div className="animate-fade-in-up h-full flex flex-col">
          {/* Title */}
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 text-center">
            Book a Call
          </h2>

          {/* Glassmorphism card with glow effect */}
          <div className="relative flex-1">
            {/* Gradient glow behind card */}
            <div className="absolute -inset-1 bg-gradient-to-r from-white/20 via-white/10 to-white/20 rounded-2xl blur-xl opacity-50" />
            
            {/* Glass card */}
            <div
              className={`relative h-full bg-white/5 backdrop-blur-xl border border-white/20 rounded-2xl shadow-2xl shadow-white/5 overflow-hidden transition-all duration-400 ease-out ${
                isLoaded
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3"
              }`}
            >
              {/* Subtle shadow overlay for depth */}
              <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" />
              
              {/* Cal.com iframe */}
              <iframe
                src="https://cal.com/ilan-klimberg?embed=true&primaryColor=FFFFFF"
                width="100%"
                height="100%"
                frameBorder="0"
                onLoad={() => setIsLoaded(true)}
                className="relative z-10 w-full h-full"
                title="Book a call with Ilan Klimberg"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingSection;
